<template>
    <div
        v-if="shown"
        :class="{'uk-open': !!shown}"
        class="uk-modal authentication"
        @click.prevent="dismiss"
    >
        <div class="uk-modal-dialog">
            <dismiss-link
                v-if="dismissable"
                @click="dismiss"
            />
            <transition name="slide" enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown" mode="out-in">
                <login
                    v-if="current_panel_id==='login'"
                    v-model="email"
                    :label-less="labelLess"
                    :dismissable="dismissable"
                    @goto="current_panel_id=$event"
                />
                <lost-password
                    v-if="current_panel_id==='password'"
                    v-model="email"
                    :label-less="labelLess"
                    :dismissable="dismissable"
                    @goto="current_panel_id=$event"
                />
                <reset-password
                    v-if="current_panel_id==='reset'"
                    v-model="email"
                    :label-less="labelLess"
                    :dismissable="dismissable"
                    @goto="current_panel_id=$event"
                />
                <!--
                <signup
                    v-if="current_panel_id==='signup'"
                    v-model="email"
                    :label-less="labelLess"
                    :dismissable="dismissable"
                    @goto="current_panel_id=$event"
                    @dismiss="dismiss"
                />
                //-->
            </transition>
        </div>
    </div>
</template>

<script type="text/javascript">
import { mapState } from "vuex"

import Login from "./Login"
import LostPassword from "./LostPassword"
import ResetPassword from "./ResetPassword"
/*
import Signup from "./Signup"
*/
import DismissLink from "../ModalDialog/DismissLink"

export default {
    components: {
        Login,
        LostPassword,
        ResetPassword,
        /*
        Signup,
        */
        DismissLink
    },
    watch: {
        profile_id: "maybe_dismiss",
        "login_request.panel_id": "maybe_switch_panel"
    },
    methods: {
        dismiss () {
            if(this.dismissable) this.$store.dispatch("UNREQUEST_LOGIN")
        },
        maybe_dismiss () {
            if(this.profile_id) this.shown = false
        },
        maybe_switch_panel () {
            if(this.shown) this.current_panel_id = (this.login_request.panel_id === true) ? "login" : this.login_request.panel_id
        }
    },
    computed: {
        ...mapState(["profile_id", "login_request"]),
        shown: {
            get () {
                return !this.profile_id && !!this.login_request && !!this.login_request.panel_id
            },
            set (show) {
                if(!show) this.dismiss()
            }
        },
        dismissable () {
            // eslint-disable-next-line
            return !!this.profile_id // !!process.env.VUE_APP_DEFAULT_PUBLIC_PATH && process.env.VUE_APP_DEFAULT_PUBLIC_PATH.match(/^\//)
        }
    },
    props: {
        labelLess: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            current_panel_id: "",
            email: ""
        }
    }
}
</script>

<style lang="less">
.modal.authentication {
    & > .modal-container {
        overflow: hidden;

        & > div {
            overflow: auto;
            animation-duration: 0.35s;

            .modal-body {
                & > .loader-container {
                    text-align: center;

                    & > .loader {
                        margin-top: 3rem;
                        margin-bottom: 3rem;
                    }
                }
            }
            .modal-footer {
                text-align: center;
            }
        }
    }
}
</style>
